import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Button, CheckBox, Form, Input, InputNumber, RadioList, RenderFields } from 'components/Form'
import { schoolHooks, validate, divisionGrades } from '.'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { change, initialize, isValid, reset } from 'redux-form'
import { useDispatch } from 'react-redux'
import { SchoolContext } from './SchoolContext'
import { concat } from 'lodash'
import { IconButton, SvgIcon } from '@mui/material'
import { ReactComponent as EditIcon } from 'assets/icons/Edit.svg';
import { alerts } from 'keys'
import { actions } from 'store'

const AffiliationCrud = () => {
    const { isSchoolsGroup, isFormEditing, setIsFormEditing, setSelectedTab, institutionCode, formname, affiliation, setInstitutionCodeApproved, institutionCodeApproved } = useContext(SchoolContext)

    const { initialFormFields, affiliationFormFields, contactFormFields, addressFormFields, divisionFormFields, generalFormFields } = schoolHooks.useFormFields()

    const crudAffiliation = schoolHooks.useCrudAffiliation()

    const { affiliationID } = useParams()

    const isEditingRef = useRef(isFormEditing)

    const dispatch = useDispatch()
    const formValues = useSelector(state => state.form.affiliationCrud)
    const isFormValid = useSelector(state => isValid(formname)(state));

    const { division, grades, institution_code } = formValues?.values || {}

    const updateGrade = useCallback((item, val) => {
        dispatch(change(formname, "grades", { ...grades, [item.value]: { active: val, name: item.label } }))
    }, [grades])

    const updateClasses = useCallback((item, val) => {
        dispatch(change(formname, "grades", {
            ...grades, [item.value]: {
                ...grades[item.value],
                classes: val
            }
        }))
    }, [grades])

    useEffect(() => {
        if (institutionCode.current && institutionCode.current != institution_code)
            setInstitutionCodeApproved(false)
        institutionCode.current = institution_code
    }, [institution_code])

    const cleanForm = useCallback(() => {
        dispatch(reset(formname))
        dispatch(initialize(formname))
    }, [])

    let gradesToMapping = []
    if (division) {
        if (division.includes("school"))
            gradesToMapping = concat(gradesToMapping, divisionGrades.school)
        if (division.includes("brigade"))
            gradesToMapping = concat(gradesToMapping, divisionGrades.brigade)
        if (division.includes("highSchool"))
            gradesToMapping = concat(gradesToMapping, divisionGrades.highSchool)
    }

    const updateIsEditing = useCallback((val) => {
        setIsFormEditing(val)
        isEditingRef.current = val
    }, [isFormEditing])

    const saveAffiliation = useCallback(async () => {
        const isValid = await crudAffiliation()
        if (isValid) {
            updateIsEditing(false)
            setSelectedTab(1)
            affiliation.refetch()
        }
    }, [isFormValid, formValues])

    useEffect(() => {
        return (() => {
            if (isEditingRef.current)
                dispatch(actions.setAlerts({
                    key: alerts.exitEditAffiliation,
                    value: { open: true, props: formValues }
                }))
        })
    }, [])

    return (
        <div className='form-content'>
            <div className={`form-fields`}>
                <Form
                    form={formname}
                    title={null}
                    validations={validate}
                    submitBtns={[]}
                    submit={() => { }}
                    initialValues={affiliationID ? affiliation?.data : {}}
                >
                    <div className='section-title'>
                        {"פרטים ראשוניים"}
                        {affiliationID &&
                            <div className={isFormEditing ? "edit-button-active" : "edit-button"}>
                                <IconButton size='small' onClick={() => updateIsEditing(val => !val)}>
                                    <SvgIcon fontSize='small' component={EditIcon} inheritViewBox />
                                </IconButton>
                            </div>}
                    </div>
                    {institutionCodeApproved ?
                        <React.Fragment>
                            <div className={`section-fields`}>
                                <RenderFields readOnly={!isFormEditing} fields={initialFormFields} />
                            </div>
                            <div className={`section-fields`}>
                                <RenderFields readOnly={!isFormEditing} fields={affiliationFormFields} />
                            </div>
                            <div className='section-title'>{"כתובת"}</div>
                            <div className={`section-fields`}>
                                <RenderFields readOnly={!isFormEditing} fields={addressFormFields} />
                            </div>
                            <div className='section-title'>{"פרטי איש הקשר"}</div>
                            <div className={`section-fields`}>
                                <RenderFields readOnly={!isFormEditing} fields={contactFormFields} />
                            </div>
                            <div className='section-title'>{"מספר תלמידים מנויים משוער"}</div>
                            <div className={`section-fields`}>
                                <RenderFields readOnly={!isFormEditing} fields={generalFormFields} />
                            </div>
                            {isSchoolsGroup &&
                                (affiliationID ?
                                    "" :
                                    <React.Fragment>
                                        <div className='section-title'>{"שכבות וכיתות לביצוע מבדקים"}</div>
                                        <div className='wrap-grades'>
                                            <RenderFields fields={divisionFormFields} />
                                            {/* מסתירים את פירוט השכבות והכיתות כל עוד אין קוד מוסד */}
                                            {institutionCodeApproved && gradesToMapping?.map((item) =>
                                                <div className='grade'>
                                                    <CheckBox
                                                        label={item.label}
                                                        input={{
                                                            value: grades?.[item.value]?.active,
                                                            onChange: (val) => {
                                                                updateGrade(item, val)
                                                            }
                                                        }}
                                                    />
                                                    {grades?.[item.value]?.active &&
                                                        <InputNumber
                                                            size="small"
                                                            color="thirdly"
                                                            placeholder="מספר כיתות בשכבה"
                                                            input={{
                                                                value: grades?.[item.value]?.classes,
                                                                onChange: (val) => {
                                                                    updateClasses(item, val)
                                                                }
                                                            }}
                                                        />
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    </React.Fragment>)
                            }
                        </React.Fragment>
                        :
                        <div className={`section-fields`}>
                            <RenderFields fields={initialFormFields} />
                        </div>
                    }
                </Form>
            </div>
            <div className={`actions ${!isFormEditing && 'disabled'}`}>
                <Button
                    label="ביטול"
                    action={cleanForm}
                    variant="white"
                />
                <Button
                    disabled={!institutionCodeApproved}
                    color="thirdly"
                    label="שמירה"
                    action={saveAffiliation}
                    variant="regular"
                />
            </div>
        </div>
    )
}

export default AffiliationCrud